module.exports = __webpack_public_path__ + "img/00040.66ec7ba6.webp";